module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-46.ba2646f5.jpg";